import { GetCountries,GetState,GetCity, } from 'react-country-state-city';

export const getCountryName = async(countryId=101) => {
  const countries = await GetCountries() || [];
  const country = countries.find((country) => country.id === countryId);
  return country ? country.name : "";
};

export const getStateName = async(countryId=101, stateId) => {
  const states = await GetState(countryId) || [];
  const state = states.find((state) => state.id === stateId);
  return state ? state.name : "";
};

export const getCityName = async(countryId=101, stateId, cityId) => {
  const cities = await GetCity(countryId,stateId) || [];
  const city = cities.find((city) => city.id === cityId);
  return city ? city.name : "";
};

